<div fxFlex="0 0 auto" class="tenant-card" [class.selected]="selected" fxLayout (click)="click.emit(this)">
  <div class="icon" fxLayout fxLayoutAlign="center center">
    <mat-icon svgIcon="eis-assets-tenant"></mat-icon>
  </div>
  <div class="title" fxFlex fxLayout fxLayoutAlign="start center"><span>{{title}}</span></div>
</div>
